import { c as _c } from "react/compiler-runtime";
import { CollectionLockup, CollectionLockupContent, CollectionLockupTitle } from "@opensea/app-kit";
import { readFragment } from "@opensea/graphql";
import { Image } from "@opensea/next-ui-kit";
import { Card, classNames, Flex, FlexColumn, TextBody, TextLabel } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { slideClasses } from "@/components/collection/overview/styles";
import { CollectionLink } from "@/components/items/collection/CollectionLink";
import { TokenPrice } from "@/components/price/TokenPrice";
import { Volume } from "@/components/price/Volume";
import { FeaturedCollectionSlideFragment } from "./FeaturedCollectionSlide.fragment";
export function FeaturedCollectionSlide(t0) {
  const $ = _c(43);
  const {
    className,
    collection: collectionKey
  } = t0;
  let t1;
  if ($[0] !== collectionKey) {
    t1 = readFragment(FeaturedCollectionSlideFragment, collectionKey);
    $[0] = collectionKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const collection = t1;
  const t = useTranslations("FeaturedCollectionSlide");
  const image = collection.featuredImageUrl ?? collection.bannerImageUrl ?? collection.imageUrl;
  let t2;
  if ($[2] !== className) {
    t2 = classNames(slideClasses(), className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = classNames("relative aspect-16/9 w-full bg-bg-additional-2");
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== image) {
    t4 = image ? <Image alt="" objectFit="cover" sizes="auto" src={image} width={800} /> : null;
    $[5] = image;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <Flex className={t3}>{t4}</Flex>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <CollectionLockupContent><CollectionLockupTitle disableTextOverflowTooltip={true} weight="semibold" /></CollectionLockupContent>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== collection) {
    t7 = <CollectionLockup collection={collection}>{t6}</CollectionLockup>;
    $[10] = collection;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t) {
    t8 = t("floorPrice");
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <TextLabel className="text-text-secondary">{t8}</TextLabel>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = collection.floorPrice?.pricePerItem;
  let t11;
  if ($[16] !== t10) {
    t11 = <TokenPrice price={t10} />;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t9) {
    t12 = <FlexColumn className="basis-1/2 gap-1">{t9}{t11}</FlexColumn>;
    $[18] = t11;
    $[19] = t9;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t) {
    t13 = t("totalVolume");
    $[21] = t;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t13) {
    t14 = <TextLabel className="text-text-secondary">{t13}</TextLabel>;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== collection.stats.volume) {
    t15 = <TextBody className="whitespace-nowrap" size="md"><Volume volume={collection.stats.volume} /></TextBody>;
    $[25] = collection.stats.volume;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t14 || $[28] !== t15) {
    t16 = <FlexColumn className="basis-1/2 items-end gap-1">{t14}{t15}</FlexColumn>;
    $[27] = t14;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t12 || $[31] !== t16) {
    t17 = <Flex className="mt-4 justify-between">{t12}{t16}</Flex>;
    $[30] = t12;
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t17 || $[34] !== t7) {
    t18 = <div className="flex-1 p-4 lg:p-6">{t7}{t17}</div>;
    $[33] = t17;
    $[34] = t7;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t18 || $[37] !== t5) {
    t19 = <Card>{t5}{t18}</Card>;
    $[36] = t18;
    $[37] = t5;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== collection || $[40] !== t19 || $[41] !== t2) {
    t20 = <CollectionLink className={t2} collection={collection}>{t19}</CollectionLink>;
    $[39] = collection;
    $[40] = t19;
    $[41] = t2;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  return t20;
}